import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    // console.log('Login attempt:', formData);
    const { username, password } = formData;
    const errors: string[] = [];

    if (!username || !username.endsWith('@gmail.com')) {
      errors.push("Username must end with '@gmail.com'.");
    }

    if (!password || password.length < 6) {
      errors.push("Password must be at least 6 characters long.");
    }

    if (errors.length > 0) {
      alert(errors.join("\n"));
      return;
    }

    console.log("Login attempt:", formData);
    navigate("/dashboard");
  };

  return (
    <div className="fixed inset-0 min-h-screen min-w-screen bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 overflow-hidden flex items-center justify-center">
      {/* Wavy Background Pattern */}
      <svg
        className="absolute inset-0 w-full h-full"
        viewBox="0 0 1920 1080"
        preserveAspectRatio="none"
        style={{ zIndex: 0, opacity: 0.1 }}
      >
        <defs>
          <pattern
            id="wavy-lines"
            width="120"
            height="80"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M0,20 Q30,10 60,20 T120,20"
              fill="none"
              stroke="white"
              strokeWidth="1.5"
              opacity="0.8"
            />
            <path
              d="M0,40 Q30,30 60,40 T120,40"
              fill="none"
              stroke="white"
              strokeWidth="1"
              opacity="0.6"
            />
            <path
              d="M0,60 Q30,50 60,60 T120,60"
              fill="none"
              stroke="white"
              strokeWidth="1.5"
              opacity="0.8"
            />
            <path
              d="M30,0 Q20,20 30,40 T30,80"
              fill="none"
              stroke="white"
              strokeWidth="1"
              opacity="0.5"
            />
            <path
              d="M90,0 Q80,20 90,40 T90,80"
              fill="none"
              stroke="white"
              strokeWidth="1"
              opacity="0.5"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#wavy-lines)" />
      </svg>

      {/* Login Card */}
      <div className="relative z-10 w-full max-w-md">
        <div className="bg-gray-800 bg-opacity-90 backdrop-blur-sm rounded-2xl p-8 shadow-2xl">
          {/* Logo */}
          <div className="text-center mb-8">
            <div className="mx-auto w-32 h-32 flex items-center justify-center mb-6 rounded-xl">
              <img
                src="/assets/galaxy_logo_transparent.png"
                alt="Galaxy Logo"
                className="w-32 h-32 object-contain"
                style={{ background: "tranparent", borderRadius: "0.75rem" }}
              />
            </div>
            <h1 className="text-2xl font-bold text-white mb-2">Galaxy ALPR</h1>
            <p className="text-gray-300 text-sm">
              Automatic License Plate Recognition
            </p>
          </div>

          {/* Login Form */}
          <div className="space-y-6">
            <div>
              <input
                type="text"
                name="username"
                placeholder="Username/Email"
                value={formData.username}
                onChange={handleInputChange}
                className="w-full px-4 py-3 bg-white bg-opacity-90 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-500"
                required
              />
            </div>

            <div>
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleInputChange}
                className="w-full px-4 py-3 bg-white bg-opacity-90 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-500"
                required
              />
            </div>

            <button
              onClick={handleSubmit}
              className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-800"
            >
              Login
            </button>
          </div>

          {/* Footer */}
          <div className="text-center mt-8">
            <p className="text-gray-400 text-sm">©2025, Galaxy Dev</p>
          </div>
        </div>
      </div>
      {/* TechnoArt 2025 Logo with white background and opacity */}
      <div
        style={{
          position: "fixed",
          right: 24,
          bottom: 0,
          zIndex: 50,
          pointerEvents: "none",
          userSelect: "none",
        }}
      >
        <div
          style={{
            background: "rgba(255,255,255,0.85)",
            borderRadius: 16,
            padding: 12,
            boxShadow: "0 2px 12px 0 rgba(0,0,0,0.10)",
            display: "inline-block",
          }}
        >
          <img
            src="/assets/logo-techno-art-2025.png"
            alt="TechnoArt 2025 Logo"
            style={{ width: 180, height: "auto" }}
            draggable={false}
          />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
